"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoboticWorkforce = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const SelectCard_1 = require("../../inputs/SelectCard");
const CardName_1 = require("../../CardName");
const Resources_1 = require("../../Resources");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const Units_1 = require("../../Units");
class RoboticWorkforce extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.ROBOTIC_WORKFORCE,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 9,
            metadata: {
                cardNumber: '086',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.text('Copy A', Size_1.Size.SMALL, true).nbsp();
                    b.production((pb) => pb.building().played);
                }),
                description: 'Duplicate only the production box of one of your building cards.',
            },
        });
    }
    canPlay(player) {
        return RoboticWorkforce.getAvailableCards(player).length > 0;
    }
    static isCardApplicable(card, player, adjustment) {
        if (!card.tags.includes(Tags_1.Tags.BUILDING) && !card.tags.includes(Tags_1.Tags.WILDCARD)) {
            return false;
        }
        if (card.name === CardName_1.CardName.BIOMASS_COMBUSTORS) {
            return player.game.someoneHasResourceProduction(Resources_1.Resources.PLANTS, 1);
        }
        if (card.name === CardName_1.CardName.HEAT_TRAPPERS) {
            return player.game.someoneHasResourceProduction(Resources_1.Resources.HEAT, 2);
        }
        if (card.name === CardName_1.CardName.GYROPOLIS) {
            return player.getProduction(Resources_1.Resources.ENERGY) >= 2;
        }
        if (card.produce !== undefined)
            return true;
        if (card.productionBox === undefined || card.productionBox === Units_1.Units.EMPTY)
            return false;
        const productionBox = Units_1.Units.adjustUnits(card.productionBox, adjustment);
        return player.canAdjustProduction(productionBox);
    }
    static getAvailableCards(player, adjustment = Units_1.Units.EMPTY) {
        const availableCards = player.playedCards.filter((card) => RoboticWorkforce.isCardApplicable(card, player, adjustment));
        player.corporationCards.forEach((corp) => {
            if (RoboticWorkforce.isCardApplicable(corp, player, adjustment))
                availableCards.push(corp);
        });
        return availableCards;
    }
    play(player) {
        const availableCards = RoboticWorkforce.getAvailableCards(player);
        return RoboticWorkforce.selectBuildingCard(player, availableCards, this.name, 'Select builder card to copy');
    }
    static selectBuildingCard(player, availableCards, source, title, cb = () => undefined) {
        if (availableCards.length === 0)
            return undefined;
        return new SelectCard_1.SelectCard(title, 'Copy', availableCards, (selectedCards) => {
            const card = selectedCards[0];
            player.game.log('${0} copied ${1} production with ${2}', (b) => b.player(player).card(card).cardName(source));
            if (card.produce) {
                card.produce(player);
            }
            else if (card.productionBox) {
                player.adjustProduction(card.productionBox);
            }
            else {
                throw new Error(`Card ${card.name} is not a valid Robotic Workforce card.`);
            }
            return cb(card);
        });
    }
}
exports.RoboticWorkforce = RoboticWorkforce;
//# sourceMappingURL=RoboticWorkforce.js.map